<template>
    <!-- 全局导航栏，无独立子组件，不会报Unknown custom element -->
    <nav class="global-nav">
        <ul class="nav-list">
            <li v-for="(item, index) in menuConfig" :key="index" class="nav-item" @mouseenter="handleEnter(index)"
                @mouseleave="handleLeave">
                <div class="nav-title" :class="{ 'active': activeIndex === index }" @click="handleMenuClick(item)">
                    {{ item.label }}
                    <span v-if="item.groups && item.groups.length" class="arrow">
                        {{ activeIndex === index ? "▲" : "▼" }}
                    </span>
                </div>

                <!-- 自适应下拉弹窗 -->
                <div v-if="item.groups && item.groups.length" v-show="activeIndex === index" class="dropdown-wrap"
                    :class="{ 'dropdown-right': isRightSide(index) }">
                    <div class="dropdown-content">
                        <div class="dropdown-decoration"></div>
                        <div v-for="(group, gIdx) in item.groups" :key="gIdx" class="dropdown-col">
                            <div class="col-item-list">
                                <div v-for="(itemObj, tIdx) in group.items" :key="tIdx" class="col-item"
                                    @click="handleJump(itemObj.route)">
                                    <span class="item-dot"></span>
                                    {{ itemObj.text }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: "App",
    data() {
        return {
            activeIndex: -1,
            timer: null,
            menuConfig: [

                {
                    label: "医学影像学导论",
                    groups: [
                        {
                            items: [
                                { text: "医学影像中心VR系统", route: "/vr" },

                            ],
                        }
                    ],
                },

                {
                    label: "医学影像设备学",
                    groups: [
                        {
                            items: [
                                { text: "MRI设备结构虚拟仿真系统", route: "/deviceMRI" },
                                { text: "CT设备结构虚拟仿真系统", route: "/deviceCT" },
                                { text: "DR设备结构虚拟仿真系统", route: "/deviceDR" },
                                { text: "MRI性能检测虚拟仿真系统", route: "/perMRI" },
                                { text: "CT性能检测虚拟仿真系统", route: "/perCT" },
                                { text: "DR性能检测虚拟仿真系统", route: "/perDR" },
                            ],
                        }
                    ],
                },
                {
                    label: "医学影像检查技术学",
                    groups: [
                        {
                            items: [
                                { text: "MRI检查技术虚拟仿真系统", route: "/checkMRI" },
                                { text: "CT检查技术虚拟仿真系统", route: "/checkCT" },
                                { text: "DR检查技术虚拟仿真系统", route: "/checkDR" },
                            ],
                        }
                    ],
                },

                {
                    label: "医学影像诊断学",
                    groups: [
                        {
                            items: [
                                { text: "医学影像诊断思维教学系统", route: "/pacs" },
                            ],
                        }
                    ],
                },
                {
                    label: "医学图像处理",
                    groups: [
                        {
                            items: [
                                { text: "医学图像处理教学系统", route: "/course" },
                            ],
                        }
                    ],
                },
                {
                    label: "医学影像解剖学",
                    groups: [
                        {
                            items: [
                                { text: "医学影像解剖图谱", route: "/dissect" },
                            ],
                        }
                    ],
                },
                {
                    label: "实训设备",
                    groups: [
                        {
                            items: [
                                { text: "MRI教学实训设备", route: "/MRI" },
                                { text: "CT教学实训设备", route: "/CT" },
                                { text: "DR教学实训设备", route: "/DR" },
                                { text: "三维影像后处理系统", route: "/handle" },
                                { text: "超声教学实训设备", route: "/supersound" },
                                { text: "桌面式教学机", route: "/desktop" },

                            ],
                        }
                    ],
                },
                {
                    label: "实训模体",
                    groups: [
                        {
                            items: [
                                { text: "医学人体模型(X线、CT、MRI)", route: "/dieBody" },
                                { text: "医学人体模型(X线、CT、超声)", route: "/dieBodyUS" },
                                // { text: "医学成人模型", route: "/adult" }, 和上方人体模型内容重复
                                { text: "医学儿童模型", route: "/children" },
                                { text: "医学兽医模型", route: "/animals" },
                                { text: "医学几何模型", route: "/geometry" },
                                // { text: '体模', route: '/phantom'} 所有模型的照片显示
                            ],
                        }
                    ],
                },
                {
                    label: "医学影像设备安装与维修学",
                    // groups: [
                    //     {
                    //         items: [
                    //             { text: "医学人体模型(X线、CT、MRI)", route: "/dieBody" },
                    //             { text: "医学人体模型(X线、CT、超声)", route: "/dieBodyUS" },

                    //         ],
                    //     }
                    // ],
                },
            ],
        };
    },
    methods: {
        handleEnter(idx) {
            if (this.timer) clearTimeout(this.timer);
            this.activeIndex = idx;
        },
        handleLeave() {
            this.timer = setTimeout(() => {
                this.activeIndex = -1;
            }, 200);
        },
        // 判断是否为右侧需要反向展开的菜单（最后4个：CT/DR/MRI/VR/DIC 这里DIC是最后一项，索引5）
        isRightSide(index) {
            // 总菜单长度 this.menuConfig.length = 6，索引 0~5
            // 当索引 >=4（VR、DIC）时，下拉框右对齐，防止溢出
            return index >= 4;
        },
        handleJump(path) {
            // 关闭下拉菜单
            this.activeIndex = -1;
            // 路由跳转
            this.$router.push(path);
        },
        handleMenuClick(item) {
            if (!item.groups || item.groups.length === 0) {
                this.showToast('医学影像设备安装与维修学课程正在迭代升级，全新内容敬请期待！')
            }
        },
        showToast(text) {
            // 先清除上一个toast，防止重复弹出
            const oldToast = document.querySelector('.global-nav-toast')
            if (oldToast) oldToast.remove()

            let toast = document.createElement('div')
            toast.className = 'global-nav-toast'
            toast.innerText = text
            toast.style = `
                        position:fixed;
                        top:130px;     
                        left:50%;
                        transform:translateX(-50%);
                        background: linear-gradient(135deg, #0969B2, #1c4979);
                        color:#fff;          
                        padding:12px 28px;
                        border-radius:12px;
                        z-index:99999;
                        font-size:15px;
                        letter-spacing:0.3px;
                        box-shadow: 0 10px 30px rgba(9, 105, 178, 0.22);
                        transition: opacity 0.3s ease;
                    `
            document.body.appendChild(toast)
            setTimeout(() => {
                toast.style.opacity = '0';
                setTimeout(() => toast.remove(), 100)
            }, 1500)
        }
    },
    beforeDestroy() {
        if (this.timer) clearTimeout(this.timer);
    },
};
</script>

<style lang="scss" scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.global-nav {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
    position: relative;
    margin-top: 80px;
    z-index: 100;

    .nav-list {
        width: 100%;
        // max-width: 1400px;
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 35px;
        list-style: none;
    }

    .nav-item {
        position: relative;
        padding: 12px 0;
        cursor: pointer;

        .nav-title {
            font-size: 18px;
            font-weight: 500;
            color: #333;
            display: flex;
            align-items: center;
            border-radius: 8px;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            position: relative;

            &::after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 50%;
                width: 0;
                height: 3px;
                background: linear-gradient(90deg, #0f3059, #1a4f7a);
                border-radius: 3px;
                transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                transform: translateX(-50%);
            }

            .arrow {
                font-size: 12px;
                color: #999;
                transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                display: inline-block;
                margin-left: 2px;
            }
        }

        &:first-child .nav-title {
            cursor: default;
        }

        // ========== 【仅修改此下拉列表样式】 ==========
        .dropdown-wrap {
            position: absolute;
            top: calc(100% + 12px);
            left: 0;
            z-index: 9999;
            animation: fadeSlideDown 0.35s cubic-bezier(0.23, 1, 0.32, 1) forwards;
            transform-origin: top center;

            @keyframes fadeSlideDown {
                0% {
                    opacity: 0;
                    transform: translateY(-16px) scale(0.95);
                }

                100% {
                    opacity: 1;
                    transform: translateY(0) scale(1);
                }
            }

            .dropdown-content {
                position: relative;
                display: flex;
                gap: 48px;
                padding: 28px 36px;
                background: linear-gradient(180deg, #ffffff 0%, #f5f9ff 100%);
                border-radius: 14px;
                white-space: nowrap;
                text-align: left;
                min-width: 380px;
                border: 1px solid rgba(66, 124, 184, 0.15);
                box-shadow:
                    0 20px 60px rgba(15, 48, 89, 0.15),
                    0 8px 24px rgba(15, 48, 89, 0.08),
                    inset 0 1px 0 rgba(255, 255, 255, 1);
                overflow: hidden;
                backdrop-filter: blur(10px);

                // 顶部极细渐变光带
                &::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 12%;
                    right: 12%;
                    height: 3px;
                    background: linear-gradient(90deg,
                            transparent 0%,
                            rgba(150, 153, 156, 0.6) 30%,
                            #1c4979 50%,
                            rgba(193, 212, 235, 0.6) 70%,
                            transparent 100%);
                    border-radius: 0 0 3px 3px;
                    opacity: 0.9;
                }

                // 背景柔和光晕
                &::after {
                    content: '';
                    position: absolute;
                    bottom: -100px;
                    right: -60px;
                    width: 240px;
                    height: 240px;
                    background: radial-gradient(circle, rgba(66, 124, 184, 0.08) 0%, transparent 70%);
                    pointer-events: none;
                }
            }

            // 顶部三角指示器
            .dropdown-decoration {
                position: absolute;
                top: -8px;
                left: 42px;
                width: 16px;
                height: 16px;
                background: #ffffff;
                transform: rotate(45deg);
                border-radius: 3px 0 0 0;
                border-left: 1px solid rgba(66, 124, 184, 0.15);
                border-top: 1px solid rgba(66, 124, 184, 0.15);
                z-index: 2;
            }

            .dropdown-col {
                position: relative;
                z-index: 3;

                .col-item-list {
                    display: flex;
                    flex-direction: column;
                    gap: 4px;

                    .col-item {
                        font-size: 15px;
                        color: #4a5a70;
                        font-weight: 400;
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        padding: 10px 14px 10px 16px;
                        border-radius: 8px;
                        cursor: pointer;
                        position: relative;
                        letter-spacing: 0.2px;
                        transition: all 0.25s cubic-bezier(0.23, 1, 0.32, 1);

                        // 左侧高亮竖条
                        &::before {
                            content: '';
                            position: absolute;
                            left: 0;
                            top: 50%;
                            transform: translateY(-50%) scaleY(0);
                            width: 3px;
                            height: 60%;
                            background: linear-gradient(180deg, #0f3059, #427cb8);
                            border-radius: 99px;
                            opacity: 0;
                            transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
                        }

                        .item-dot {
                            display: inline-block;
                            width: 6px;
                            height: 6px;
                            border-radius: 50%;
                            background: #c8d8e9;
                            flex-shrink: 0;
                            transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
                        }

                        &:hover {
                            background: linear-gradient(90deg,
                                    rgba(66, 124, 184, 0.1) 0%,
                                    rgba(15, 48, 89, 0.04) 100%);
                            transform: translateX(4px);
                            color: #0f3059;
                            font-weight: 500;

                            &::before {
                                opacity: 1;
                                transform: translateY(-50%) scaleY(1);
                            }

                            .item-dot {
                                background: #3c7fc0;
                                transform: scale(1.6);
                                box-shadow: 0 0 12px rgba(66, 124, 184, 0.5);
                            }
                        }

                        &:active {
                            transform: translateX(2px) scale(0.98);
                        }
                    }
                }
            }

            // 右侧对齐反向样式
            &.dropdown-right {
                left: auto !important;
                right: 0;
                transform-origin: top right;

                .dropdown-decoration {
                    left: auto;
                    right: 42px;
                }

                .dropdown-content::before {
                    left: 20%;
                    right: 20%;
                }
            }
        }

        // ========== 下拉列表样式修改结束 ==========
    }
}

.page-content {
    padding: 30px;
    font-size: 20px;
}
</style>